import { useMemo, useState } from "react";
import { ArrowUp, ArrowDown, ChevronsUpDown } from "lucide-react";

// Tablo sıralaması için yeniden kullanılabilir hook.
// column accessor'lar bir map ile verilir: { key: (row) => value }
export function useSort(data, accessors = {}, initialKey = null, initialDir = "asc") {
  const [sortKey, setSortKey] = useState(initialKey);
  const [sortDir, setSortDir] = useState(initialDir);

  const toggle = (key) => {
    if (sortKey === key) {
      setSortDir((d) => (d === "asc" ? "desc" : "asc"));
    } else {
      setSortKey(key);
      setSortDir("asc");
    }
  };

  const sorted = useMemo(() => {
    if (!sortKey) return data;
    const get = accessors[sortKey] || ((row) => row?.[sortKey]);
    const arr = [...data];
    arr.sort((a, b) => {
      let av = get(a);
      let bv = get(b);
      av = av == null ? "" : av;
      bv = bv == null ? "" : bv;
      let cmp;
      if (typeof av === "number" && typeof bv === "number") {
        cmp = av - bv;
      } else {
        cmp = String(av).localeCompare(String(bv), "tr", { numeric: true, sensitivity: "base" });
      }
      return sortDir === "asc" ? cmp : -cmp;
    });
    return arr;
  }, [data, sortKey, sortDir, accessors]);

  return { sorted, sortKey, sortDir, toggle };
}

// Tıklanınca sıralayan tablo başlığı hücresi.
export function SortHeader({ label, sortId, sort, align = "left", className = "" }) {
  const active = sort.sortKey === sortId;
  const Icon = active ? (sort.sortDir === "asc" ? ArrowUp : ArrowDown) : ChevronsUpDown;
  const justify = align === "right" ? "justify-end" : align === "center" ? "justify-center" : "justify-start";
  return (
    <th className={`px-5 py-3.5 font-semibold ${align === "right" ? "text-right" : align === "center" ? "text-center" : "text-left"} ${className}`}>
      <button
        type="button"
        data-testid={`sort-${sortId}`}
        onClick={() => sort.toggle(sortId)}
        className={`inline-flex w-full items-center gap-1 ${justify} uppercase tracking-wider transition-colors hover:text-foreground ${active ? "text-foreground" : ""}`}
      >
        <span>{label}</span>
        <Icon className={`h-3 w-3 ${active ? "opacity-90" : "opacity-40"}`} />
      </button>
    </th>
  );
}
